(function (root, factory) {
  'use strict';
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  else { root.MMCollectorCloudBridge = api; api.mount(); }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';
  var PROJECT = 'https://pnlenowzewtmwoyasxbq.supabase.co';
  var PUBLIC_KEY = 'sb_publishable_MF16GLFsaKp-6p2ivHMJlg_fQ6VEoD4';
  var TABLE = 'mm_collector_private_state_v1';
  var VAULT = '/functions/v1/collector-member-vault/engine-state';
  var FIELDS = ['recordId','catalogId','canonicalId','title','url','manufacturer','casting','releaseYear','series','toyNumber','collectorNumber','bodyColor','wheelType','baseMarkings','scale','condition','packaging','quantity','status','purchasePrice','purchaseCurrency','purchasePriceBasis','currency','acquisitionCurrency','askingCurrency','purchaseDate','acquisitionSource','storageLocation','askingPrice','realizedPrice','realizedCurrency','realizedPriceBasis','soldAt','saleFees','saleShippingCost','notes','favorite','imageUrl','photoPaths','listIds','createdAt','updatedAt'];
  var LIST_FIELDS = ['listId','name','createdAt','updatedAt'];
  function fail(code, message) { var e = new Error(message); e.code = code; return e; }
  function copyFields(value, fields) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw fail('CLOUD_INVALID_STATE', 'Collection data could not be validated.');
    var out = {};
    fields.forEach(function (key) {
      if (!Object.prototype.hasOwnProperty.call(value, key)) return;
      var v = value[key];
      if (key === 'listIds') {
        if (!Array.isArray(v) || !v.every(function (id) { return typeof id === 'string'; })) throw fail('CLOUD_INVALID_STATE', 'Collection list references could not be validated.');
      } else if (key === 'photoPaths') {
        if (!Array.isArray(v) || v.length > 8 || !v.every(function (path) { return typeof path === 'string' && /^[0-9a-f-]{36}\/[a-zA-Z0-9_.:@/-]+$/i.test(path) && path.indexOf('..') < 0; })) throw fail('CLOUD_INVALID_STATE', 'Private photo references could not be validated.');
      } else if (v != null && !['string','number','boolean'].includes(typeof v)) {
        throw fail('CLOUD_INVALID_STATE', 'Collection data could not be validated.');
      }
      out[key] = v;
    });
    return out;
  }
  // Cloud payloads contain collection data only; never auth/session/config objects.
  function snapshot(state) {
    if (!state || state.schemaVersion !== 1 || !Number.isSafeInteger(state.revision) || state.revision < 0 ||
        typeof state.updatedAt !== 'string' || !Number.isFinite(Date.parse(state.updatedAt)) || !Array.isArray(state.records) || !Array.isArray(state.lists)) throw fail('CLOUD_INVALID_STATE', 'Collection data could not be validated.');
    var ledger = Object.create(null);
    if (state.migrationLedger && typeof state.migrationLedger === 'object') {
      Object.keys(state.migrationLedger).sort().forEach(function (key) {
        if (!/^[a-zA-Z0-9_-]{1,160}$/.test(key) || ['__proto__','constructor','prototype'].includes(key)) throw fail('CLOUD_INVALID_STATE', 'Collection migration metadata could not be validated.');
        var entry = state.migrationLedger[key];
        if (!entry || typeof entry !== 'object') throw fail('CLOUD_INVALID_STATE', 'Collection migration metadata could not be validated.');
        ledger[key] = copyFields(entry, ['recordId','sourceHash','recordHash']);
      });
    }
    if (state.trash !== undefined && !Array.isArray(state.trash)) throw fail('CLOUD_INVALID_STATE', 'Collection trash could not be validated.');
    var trash = (state.trash || []).map(function (entry) {
      if (!entry || typeof entry.recordId !== 'string' || typeof entry.deletedAt !== 'string' ||
          !Number.isFinite(Date.parse(entry.deletedAt))) throw fail('CLOUD_INVALID_STATE', 'Collection trash could not be validated.');
      var record = copyFields(entry.record,FIELDS);
      if (record.recordId !== entry.recordId) throw fail('CLOUD_INVALID_STATE', 'Collection trash identity could not be validated.');
      return {recordId:entry.recordId,record:record,deletedAt:entry.deletedAt};
    });
    return JSON.parse(JSON.stringify({schemaVersion:1, revision:state.revision,
      records:state.records.map(function (x) { return copyFields(x, FIELDS); }),
      lists:state.lists.map(function (x) { return copyFields(x, LIST_FIELDS); }), trash:trash, updatedAt:state.updatedAt,migrationLedger:ledger}));
  }
  // Read-only preflight. Never infer a price basis or rewrite a catalog identity.
  function reviewSnapshot(state) {
    var rows = state && Array.isArray(state.records) ? state.records : [];
    var issues = [], issueCount = 0, affected = new Set();
    function issue(record, field, code, message) {
      issueCount++; affected.add(record.recordId);
      if (issues.length < 100) issues.push({recordId:record.recordId, title:record.title || 'Collection item', field:field, code:code, message:message});
    }
    rows.forEach(function (record) {
      if (!record || typeof record !== 'object') return;
      // Unknown basis is supported by the deployed backend and stays excluded from totals.
      // Only malformed explicit values require correction; never force an invented basis.
      if (record.purchasePriceBasis != null && record.purchasePriceBasis !== '' &&
          record.purchasePriceBasis !== 'unit' && record.purchasePriceBasis !== 'lot') {
        issue(record, 'purchasePriceBasis', 'COST_BASIS_INVALID', 'Choose Unknown, Each item, or Entire quantity. An unknown basis can be saved without estimating a total.');
      }
      var catalog = typeof record.catalogId === 'string' ? record.catalogId.trim() : '';
      var canonical = typeof record.canonicalId === 'string' ? record.canonicalId.trim() : '';
      // Either existing identifier may be supplied alone. Server resolution preserves
      // exact release identity without inventing a match for an unresolved reference.
      if (canonical && catalog && canonical !== catalog) {
        var uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        if (!(uuid.test(canonical) && uuid.test(catalog) && canonical.toLowerCase() === catalog.toLowerCase())) {
          issue(record, 'catalogId', 'CATALOG_LINK_CONFLICT', 'This item has two different catalog references. Review the match before cloud saving; neither identifier has been changed.');
        }
      }
    });
    return {issueCount:issueCount, affectedRecords:affected.size, issues:issues, truncated:issueCount > issues.length};
  }
  function requireReviewedSnapshot(state) {
    var review = reviewSnapshot(state);
    if (!review.issueCount) return;
    var error = fail('CLOUD_REVIEW_REQUIRED', review.affectedRecords + ' collection ' + (review.affectedRecords === 1 ? 'record needs' : 'records need') +
      ' review before cloud saving. ' + review.issues[0].message + ' Your local records and JSON backup remain unchanged.');
    error.review = review;
    throw error;
  }
  function createAdapter(options) {
    options = options || {};
    var fetcher = options.fetch || (root.fetch && root.fetch.bind(root));
    var storage = options.storage;
    if (!storage) { try { storage = root.localStorage; } catch (_) { storage = null; } }
    var consent = false, userId = null, rowRevision, payloadRevision, enabledGeneration = 0;
    var controllers = new Set();
    var adapter = {authenticated:false, allowCreate:true, scopeId:null,lastCloudUpdatedAt:null};
    var base = options.url || PROJECT, pub = options.publishableKey || PUBLIC_KEY;
    if (base.replace(/\/$/, '') !== PROJECT || !/^sb_publishable_[A-Za-z0-9_-]+$/.test(pub)) {
      throw fail('CLOUD_CONFIG', 'Collector Cloud configuration is unavailable.');
    }
    base = PROJECT;
    function reportError(error) {
      if (error && ['CLOUD_AUTH_REQUIRED','CLOUD_ACCOUNT_CHANGED','CLOUD_SESSION_CHANGED','CLOUD_CONFIG','CLOUD_MEMBERSHIP_REQUIRED'].includes(error.code)) {
        adapter.authenticated = false;
        if (typeof options.onStatus === 'function') options.onStatus('error',error.message);
      }
      return error;
    }
    function session() {
      var keys = ['mmcc-session','mm-collector-cloud-session'];
      for (var i = 0; i < keys.length; i++) {
        var candidate;
        try { candidate = JSON.parse(storage.getItem(keys[i]) || 'null'); }
        catch (_) { break; }
        if (candidate === null) continue;
        // A malformed or expired primary session never falls through to another account.
        if (candidate && typeof candidate.access_token === 'string' &&
            /^[A-Za-z0-9._~-]{21,16383}$/.test(candidate.access_token) &&
            (candidate.expires_at == null || Number.isFinite(Number(candidate.expires_at)) && Number(candidate.expires_at) > Date.now() / 1000)) return candidate;
        break;
      }
      throw fail('CLOUD_AUTH_REQUIRED', 'Sign in to your Collector account before enabling sync. Your collection is saved on this device.');
    }
    async function request(path, config, accessToken) {
      if (!fetcher) throw fail('CLOUD_UNAVAILABLE', 'Cloud sync is unavailable. Your collection remains on this device.');
      config = config || {};
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      if (controller) controllers.add(controller);
      var timer = controller ? setTimeout(function () { controller.abort(); }, 15000) : null;
      try {
        var response = await fetcher(base + path, {
          method:config.method || 'GET', credentials:'omit', cache:'no-store',
          signal:controller && controller.signal,
          headers:{apikey:pub, Authorization:'Bearer ' + accessToken, 'Content-Type':'application/json', Prefer:'return=representation'},
          body:config.body ? JSON.stringify(config.body) : undefined
        });
        if (!response.ok) {
          // Classify configuration errors without exposing upstream bodies or keys.
          if (response.status === 400 || response.status === 401) {
            var problem = await response.json().catch(function () { return null; });
            var reason = problem && typeof problem.message === 'string' ? problem.message : '';
            if (/invalid api key|no api key found/i.test(reason)) throw fail('CLOUD_CONFIG', 'Collector Cloud connection configuration needs attention. Your collection remains saved on this device.');
          }
          if (response.status === 409) throw fail('CLOUD_CONFLICT', 'Cloud data changed on another device. Your local collection has been kept.');
          if (response.status === 401 || response.status === 403) {
            adapter.authenticated = false;
            throw fail(response.status === 403 ? 'CLOUD_ACCESS_DENIED' : 'CLOUD_AUTH_REQUIRED', response.status === 403 ? 'Collector Cloud access was denied for this account. Local collection data and export remain available.' : 'Your existing Collector Cloud sign-in needs attention. Local collection data has been kept.');
          }
          throw fail('CLOUD_UNAVAILABLE', 'Cloud sync is unavailable. Your collection remains on this device.');
        }
        var result = await response.json();
        if (result && (result.ok === false || result.error)) throw fail('CLOUD_INVALID_STATE', 'Cloud returned an error instead of a confirmed collection receipt. Local data has been kept.');
        return result;
      } catch (error) {
        if (!consent) throw fail('CLOUD_CONSENT_REQUIRED', 'Cloud sync was turned off.');
        if (error && error.code) throw reportError(error);
        throw fail('CLOUD_UNAVAILABLE', 'Cloud sync could not finish. Your collection remains on this device.');
      } finally { if (timer) clearTimeout(timer); if (controller) controllers.delete(controller); }
    }
    async function verified(requirePaid) {
      if (!consent) throw fail('CLOUD_CONSENT_REQUIRED', 'Enable private cloud sync before connecting.');
      var generation = enabledGeneration, current, user;
      try {
        current = session();
        user = await request('/auth/v1/user', null, current.access_token);
        active(generation,current.access_token);
      } catch (error) { throw reportError(error); }
      if (!user || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(user.id) || user.is_anonymous === true || typeof user.email !== 'string' || typeof user.email_confirmed_at !== 'string' || !Number.isFinite(Date.parse(user.email_confirmed_at))) {
        adapter.authenticated = false;
        throw reportError(fail('CLOUD_AUTH_REQUIRED', 'Sign in to your Collector account before syncing.'));
      }
      if (userId && userId !== user.id) {
        adapter.authenticated = false;
        throw reportError(fail('CLOUD_ACCOUNT_CHANGED', 'The signed-in account changed. Turn sync off and on before continuing. Local data has been kept.'));
      }
      userId = user.id;
      adapter.scopeId = userId;
      if (requirePaid !== false) {
        var membership = await request('/functions/v1/collector-universe-api/membership',null,current.access_token);
        active(generation,current.access_token);
        if (!membership || membership.active !== true || membership.verified !== true ||
            typeof membership.expiresAt !== 'string' || Date.parse(membership.expiresAt) <= Date.now() || !Number.isFinite(Date.parse(membership.expiresAt))) {
          throw reportError(fail('CLOUD_MEMBERSHIP_REQUIRED','An active collector membership is required for cloud sync. Existing device data and export remain available.'));
        }
      }
      adapter.authenticated = true;
      return {token:current.access_token, generation:generation};
    }
    function active(generation, accessToken) {
      if (!consent || generation !== enabledGeneration) throw fail('CLOUD_CONSENT_REQUIRED', 'Cloud sync was turned off.');
      try {
        if (accessToken && session().access_token !== accessToken) {
          throw fail('CLOUD_SESSION_CHANGED', 'Your Collector Cloud sign-in changed during sync. Retry with your current sign-in; local data has been kept.');
        }
      } catch (error) { throw reportError(error); }
    }
    function rowState(row, expectedRowRevision, allowVirtual) {
      if (!row || (!(allowVirtual && row.revision === null) && (!Number.isSafeInteger(row.revision) || row.revision < 1)) ||
          (expectedRowRevision !== undefined && row.revision !== expectedRowRevision) ||
          (typeof row.user_id !== 'string' || row.user_id !== userId)) throw fail('CLOUD_INVALID_STATE', 'Cloud response could not be validated. Local data has been kept.');
      var value = snapshot(row.payload);
      if (row.updated_at != null && (typeof row.updated_at !== 'string' || !Number.isFinite(Date.parse(row.updated_at)))) {
        throw fail('CLOUD_INVALID_STATE', 'Cloud timestamp could not be validated. Local data has been kept.');
      }
      return value;
    }
    adapter.enable = async function (settings) {
      if (!settings || settings.consent !== true) throw fail('CLOUD_CONSENT_REQUIRED', 'Enable private cloud sync before connecting.');
      consent = true; enabledGeneration++; rowRevision = undefined; payloadRevision = undefined;
      adapter.lastCloudUpdatedAt = null;
      var generation = enabledGeneration;
      try { await verified(false); return adapter; }
      catch (error) { if (generation === enabledGeneration) { consent = false; adapter.authenticated = false; } throw error; }
    };
    adapter.disable = function () {
      consent = false; adapter.authenticated = false; userId = null; adapter.scopeId = null;
      adapter.lastCloudUpdatedAt = null;
      rowRevision = undefined; payloadRevision = undefined; enabledGeneration++;
      controllers.forEach(function (controller) { controller.abort(); }); controllers.clear();
    };
    adapter.isAuthenticated = async function () { if (!consent) return false; await verified(false); return true; };
    // Explicit read-only owner recovery is available after paid access expires.
    // This never attaches an adapter to the engine or enables any write operation.
    adapter.recoverBackup = async function (settings) {
      if (!settings || settings.consent !== true) throw fail('CLOUD_CONSENT_REQUIRED','Choose cloud backup recovery before connecting.');
      consent=true;enabledGeneration++;
      try {
        var auth=await verified(false),result=await request('/functions/v1/collector-member-vault/engine-recovery',null,auth.token);
        active(auth.generation,auth.token);
        if(!result||!Object.prototype.hasOwnProperty.call(result,'state'))throw fail('CLOUD_INVALID_STATE','Cloud backup could not be validated.');
        return result.state===null?null:rowState(result.state,undefined,true);
      } finally {adapter.disable();}
    };
    adapter.load = async function () {
      var auth = await verified(false);
      var result = await request(VAULT,null,auth.token);
      active(auth.generation,auth.token);
      if (!result || !Object.prototype.hasOwnProperty.call(result,'state')) throw fail('CLOUD_INVALID_STATE', 'Cloud data could not be validated. Local data has been kept.');
      if (result.state === null) { rowRevision = null; payloadRevision = null; adapter.lastCloudUpdatedAt = null; return null; }
      var row = result.state, state = rowState(row,undefined,true);
      rowRevision = row.revision; payloadRevision = state.revision;
      adapter.lastCloudUpdatedAt = row.updated_at || null;
      return state;
    };
    adapter.save = async function (state, settings) {
      var payload = snapshot(state);
      requireReviewedSnapshot(payload);
      var auth = await verified(false);
      if (rowRevision === undefined) throw fail('CLOUD_LOAD_REQUIRED', 'Read the cloud collection before saving it.');
      if (settings && Object.prototype.hasOwnProperty.call(settings, 'expectedRevision') && settings.expectedRevision !== payloadRevision) {
        throw fail('CLOUD_CONFLICT', 'Cloud data changed. Your local collection has been kept.');
      }
      var creating = rowRevision === null, next = creating ? 1 : rowRevision + 1;
      if (!Number.isSafeInteger(next) || next > 2147483647) throw fail('CLOUD_INVALID_STATE', 'Cloud revision limit reached.');
      var body = {expectedRevision:rowRevision,payload:payload};
      var result = await request(VAULT, {method:'POST',body:body}, auth.token);
      active(auth.generation,auth.token);
      if (!result || !result.state) throw fail('CLOUD_CONFLICT', 'Cloud data changed on another device. Your local collection has been kept.');
      var returned = rowState(result.state);
      // An identical retry may be acknowledged without another row revision.
      // Accept that only when every validated collection field is identical.
      var idempotent = result.state.revision === rowRevision && JSON.stringify(returned) === JSON.stringify(payload);
      if (result.state.revision !== next && !idempotent) throw fail('CLOUD_INVALID_STATE', 'Cloud response could not be validated. Local data has been kept.');
      // A new revision alone is not proof that this exact collection was saved.
      // Compare the full validated receipt before advancing the local cloud baseline.
      if (JSON.stringify(returned) !== JSON.stringify(payload)) throw fail('CLOUD_INVALID_STATE', 'The cloud save receipt does not match the collection sent. Local data has been kept; reload cloud state before retrying.');
      rowRevision = result.state.revision; payloadRevision = returned.revision;
      adapter.lastCloudUpdatedAt = result.state.updated_at || null;
      return returned;
    };
    return adapter;
  }
  function mount() {
    if (!root.document || root.__mmCollectorCloudBridgeMounted) return;
    root.__mmCollectorCloudBridgeMounted = true;
    var adapter = createAdapter({onStatus:status}), pending = 0;
    function status(code, text) {
      root.document.querySelectorAll('[data-mm-engine-cloud-status]').forEach(function (node) { node.textContent = text; });
      if (root.CustomEvent) root.dispatchEvent(new root.CustomEvent('mm:collector-cloud-status', {detail:{status:code,updatedAt:adapter && adapter.lastCloudUpdatedAt || null}}));
    }
    root.addEventListener('mm:collector-cloud-opt-in', async function (event) {
      var attempt = ++pending, engine = root.MMCollectorEngine;
      if (!engine) return;
      if (!event.detail || event.detail.enabled !== true) {
        adapter.disable();
        if (engine.setCloudConsent) engine.setCloudConsent(false);
        engine.setCloudAdapter(null);
        status('disabled', 'Cloud sync is off. Your collection is saved on this device.');
        return;
      }
      status('connecting', 'Checking your existing Collector Cloud sign-in…');
      try {
        await adapter.enable({consent:true});
        if (attempt !== pending) return;
        engine.setCloudAdapter(adapter, {consent:true});
        status('ready', 'Private cloud sync is enabled. Choose Sync now to save or retrieve your collection.');
      } catch (error) {
        if (attempt !== pending) return;
        engine.setCloudAdapter(null);
        status('error', error.message);
      }
    });
  }
  return {version:"2026-10-14.4",createAdapter:createAdapter, snapshot:snapshot, reviewSnapshot:reviewSnapshot, mount:mount,downloadRecovery:async function(options){return createAdapter(options).recoverBackup({consent:true});}};
});
